export default __webpack_public_path__ + "static/custom-tooltips-5d788240a2a611fccee8fa21aa5022ee.png";